import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import ProtectedRoute from './components/ProtectedRoute';
import NavigateSetter from './components/NavigateSetter';

import LoginPage           from './pages/LoginPage';
import RegisterPage        from './pages/RegisterPage';
import ConfirmEmailPage    from './pages/ConfirmEmailPage';
import ForgotPasswordPage  from './pages/ForgotPasswordPage';
import ResetPasswordPage   from './pages/ResetPasswordPage';
import ProfileViewPage     from './pages/ProfileViewPage';
import ProfileEditPage     from './pages/ProfileEditPage';
import AdminPerformersPage        from './pages/AdminPerformersPage';
import AdminPerformerDetailPage   from './pages/AdminPerformerDetailPage';
import AdminPerformerEditPage     from './pages/AdminPerformerEditPage';
import AdminSettingsPage          from './pages/AdminSettingsPage';
import AdminEmailTemplatesPage    from './pages/AdminEmailTemplatesPage';
import AdminDistributionListPage  from './pages/AdminDistributionListPage';
import AdminEventsPage            from './pages/AdminEventsPage';
import AdminEventDetailPage       from './pages/AdminEventDetailPage';
// Shown for any address matching no route (replaces a silent redirect to /login)
import NotFoundPage               from './pages/NotFoundPage';

function App() {
  return (
    <BrowserRouter>
      <NavigateSetter />
      <Routes>
        {/* Public */}
        <Route path="/login"            element={<LoginPage />} />
        <Route path="/register"         element={<RegisterPage />} />
        <Route path="/confirm-email"    element={<ConfirmEmailPage />} />
        <Route path="/forgot-password"  element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

        {/* Performer */}
        <Route
          path="/profile"
          element={<ProtectedRoute roles={['performer']} element={<ProfileViewPage />} />}
        />
        <Route
          path="/profile/edit"
          element={<ProtectedRoute roles={['performer']} element={<ProfileEditPage />} />}
        />

        {/* Admin / MetaAdmin / Booking Manager — performers list and detail */}
        <Route
          path="/admin"
          element={<ProtectedRoute roles={['admin', 'metaadmin', 'booking_manager']} element={<AdminPerformersPage />} />}
        />
        <Route
          path="/admin/performers/:id"
          element={<ProtectedRoute roles={['admin', 'metaadmin', 'booking_manager']} element={<AdminPerformerDetailPage />} />}
        />
        <Route
          path="/admin/performers/:id/edit"
          element={<ProtectedRoute roles={['admin', 'metaadmin']} element={<AdminPerformerEditPage />} />}
        />

        {/* Admin / MetaAdmin only — anyone else lands on the performers list */}
        <Route
          path="/admin/settings"
          element={<ProtectedRoute roles={['admin', 'metaadmin']} redirectTo="/admin" element={<AdminSettingsPage />} />}
        />
        <Route
          path="/admin/email-templates"
          element={<ProtectedRoute roles={['admin', 'metaadmin']} redirectTo="/admin" element={<AdminEmailTemplatesPage />} />}
        />
        <Route
          path="/admin/distribution-list"
          element={<ProtectedRoute roles={['admin', 'metaadmin']} redirectTo="/admin" element={<AdminDistributionListPage />} />}
        />
        {/* Both of these tabs folded into Distribution & Venues. Kept as
            redirects so bookmarks and any old links still land somewhere real. */}
        <Route path="/admin/people"       element={<Navigate to="/admin/distribution-list" replace />} />
        <Route path="/admin/admin-emails" element={<Navigate to="/admin/distribution-list" replace />} />
        {/* Booking managers belong here: booking events is the job. The tab bar
            has always offered them an Events tab, while these guards bounced
            them straight back to the performers list - a visible tab that did
            nothing, with no error to explain it.
            Deleting an event is the one thing they cannot do, and that is
            enforced in routes/events.js where it belongs, not by hiding a screen. */}
        <Route
          path="/admin/events"
          element={<ProtectedRoute roles={['admin', 'metaadmin', 'booking_manager']} redirectTo="/admin" element={<AdminEventsPage />} />}
        />
        <Route
          path="/admin/events/:id"
          element={<ProtectedRoute roles={['admin', 'metaadmin', 'booking_manager']} redirectTo="/admin" element={<AdminEventDetailPage />} />}
        />

        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        {/* This used to redirect to /login, which is precisely why the dead
            invite link went unnoticed for a week - see NotFoundPage. */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
